import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { Store } from '@ngxs/store';
import { HomeLocationState } from 'src/states';
import { catchError, filter, map, of, timeout } from 'rxjs';
import { Logout } from 'src/modules/security/actions/auth-actions';

export const homeAccountRequiredGuard: CanActivateFn = () => {
  const store = inject(Store);
  const homeUserLocation$ = store.select(HomeLocationState.userLocation);

  return homeUserLocation$.pipe(
    map(homeUserLocation => !!homeUserLocation),
    filter(isPresent => isPresent),
    timeout(30000),
    catchError(() => {
      store.dispatch(new Logout());
      return of(false);
    })
  );
};
